import React, { forwardRef } from 'react';

interface EyeFullSlashProps {
  classes?: string;
  style?: React.CSSProperties;
}

export const EyeFullSlash = forwardRef<HTMLElement, EyeFullSlashProps>(({ classes, style = {} }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-eye-slash ${classes || ''}`} style={style}></i>
  );
});

EyeFullSlash.displayName = 'EyeFullSlash';